import { ServiceData } from '@/types';

import audios from './MEDITATION_AUDIOS_BG.json';
import guides from './MEDITATION_GUIDES_BG.json';

export const MEDITATION_DATA_BG: ServiceData = {
  audios,
  guides,
};
